import React, { Component } from 'react';
import 'react-bootstrap';
import { connect } from "react-redux";
import $ from "jquery/dist/jquery.js";

class ScrollToTop extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);

    }

    componentDidUpdate() {
    }

    componentWillReceiveProps(newProps) {
        
    }

    handleScroll(event) {
        if (window.scrollY > 50) {
            $("#nav_box").addClass('show-me');

            window.activeRightBarItem();
        } else {
            $("#nav_box").removeClass('show-me');
        }
    }

    render() {

        return (
            <nav className="ftco-navbar-light site-navbar-target">

                <div id="nav_box" ref="navbox" className="collapse navbar-collapse header-floating" style={{ display: 'none' }}>
                    <ul className="navbar-nav nav sidebar-nav  ml-auto" style={{ position: 'fixed', right: '50px', bottom: '100px' }}>
                        <li className="nav-item shortbar-item">
                            <a href="#" className="nav-link sidebar-link" title=""><i className="icon icon-arrow-up"></i></a>
                        </li>
                    </ul>
                    
                </div>
            </nav>
        );
    }
}

function mapStateToProps(state) {
    return {
    };
}

export default connect(mapStateToProps)(ScrollToTop);